<app-tabla
  [totalCount]="totalCount"
  [datos]="EnviosVehiculos"
  [filtros]="filtros"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [showHijos]="false"
  [emptyState]="{ title: 'Todavía no hay envíos de vehículos' }"
></app-tabla>
